import React, { useEffect, useState } from 'react'
import './style.css'
import { Spin } from 'antd';
import { IoCloseCircle, IoSearch } from "react-icons/io5";
import { useQuery } from 'react-query';
import { LoadingOutlined } from '@ant-design/icons';
import { setError } from '../../../store/common/generalSlice';
import { useDispatch } from 'react-redux';
import useMyGarageApi from '../../../config/hooks/api/mygarage/useMyGarageApi';
import { FaCircleCheck } from 'react-icons/fa6';

const CarRegCustomSelectBox = (props) => {

    const { getVehicleByRegNum, verifyVehicle } = useMyGarageApi()

    // state to handle the view of dropdown.
    const [isSearching, setIsSearching] = useState(false);
    // state to handle the value of searchbar.
    const [searchValue, setSearchValue] = useState('');
    // state to handle the selected value from dropdown.
    const [selectedOption, setSelectedOption] = useState('');
    // state to call the useQuery conditionally.
    const [isRegNoAvailable, setIsRegNoAvailable] = useState(false)
    const [hasVehicle, setHasVehicle] = useState(false)
    const [editData, setEditData] = useState(props?.onEdit())

    const dispatch = useDispatch()

    // function to call to get a registration car number.
    const getRegisteredCar = async (carNo) => {
        let vehicleRegistrationNumber = carNo?.queryKey[1].toUpperCase();
        try {
            let res;
            if (props?.useApi && props?.useApi == 'verifyVehicle') {
                if (vehicleRegistrationNumber.length == 7 && isRegNoAvailable) {
                    res = await verifyVehicle({ vehicleRegistrationNumber });
                    // an optional prop just to send the data to the AddCar Component of myGarage to show verified car card.
                    if (res?.status == 200 || res?.status == 201) {
                        if (res?.data?.newVehicle) {
                            props?.myCar && props?.myCar(res?.data?.newVehicle)
                            setHasVehicle(true)
                        }
                    }
                }
                else {
                    setIsRegNoAvailable(false)
                }
            }
            else {
                if (vehicleRegistrationNumber?.length == 16 && vehicleRegistrationNumber?.startsWith('AAA')) {
                    res = await verifyVehicle({ vehicleRegistrationNumber })
                }
                else if (vehicleRegistrationNumber?.length == 7) {
                    res = await verifyVehicle({ vehicleRegistrationNumber })
                }
            }

            if (res) {
                if (props?.useApi && props?.useApi == 'verifyVehicle') {
                    setSelectedOption('');
                    setIsSearching(false);
                    setIsRegNoAvailable(false);
                    document.querySelector('form#verifyCarForm')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
                }
                else {
                    setSelectedOption('');
                    setIsSearching(false);
                    setIsRegNoAvailable(false);
                    if (res?.status == 200 || res?.status == 201) {
                        props?.myCar && props?.myCar(res)
                        if (res?.data?.newVehicle) setHasVehicle(true)
                        else dispatch(setError('Vehicle record not found'))
                    }
                }
            }

        } catch (error) {
            setIsRegNoAvailable(false)
            setIsSearching(false)
            setSelectedOption('')
            setHasVehicle(false)
        }
    }

    // useQuery to handle the 'Get' call, Loading is destructured from here
    const { isLoading } = useQuery(['registeredCar', searchValue], getRegisteredCar, {
        enabled: isRegNoAvailable == true
    })

    const searchIconHandler = () => {
        // starting with 'aaa' pattern is what backend is generating for the users that don't have the
        // registration number of car. so we will only allow searching either it will be actual reg.number
        // of length 7  or if it's starting from aaa.
        if (searchValue.length == 7 || searchValue.startsWith('AAA')) {
            // call an api
            setIsRegNoAvailable(true);
        } else {
            setIsRegNoAvailable(false)
            setIsSearching(false)
            setHasVehicle(false)
        }
    }

    const searchValueHandler = (val) => {
        setSearchValue(val);
        props?.onChange && props?.onChange(val)
        if (val.length < 7) {
            props?.myCar && props?.myCar(null)
            setHasVehicle(false)
        }
    }

    const selectValueHandler = () => {
        props?.onChange && props?.onChange(searchValue);
        setIsSearching(false);
    }

    const resetInput = () => {
        setIsRegNoAvailable(false)
        setIsSearching(false)
        setHasVehicle(false)
        setSearchValue('')
    }

    useEffect(() => {
        if (isRegNoAvailable) {
            setTimeout(() => {
                setIsRegNoAvailable(false)
            }, 2000);
        }
    }, [isRegNoAvailable])

    useEffect(() => {
        if (editData) {
            setSearchValue(editData)
        }
    }, [editData])

    useEffect(() => {
      if(props?.reset){
        setSearchValue('')
        setHasVehicle(false)
      }
    }, [props?.reset])
    

    return (
        <div className='w-full flex relative'>
            <div className='flex items-center'>
                <div className='bg-[#003399] h-full flex items-center flex-col justify-center px-2 rounded-tl-sm rounded-bl-sm'>
                    <div className='rounded-full w-4 h-4 p-1 border border-dotted border-[##fab700]'></div>
                    <span className='text-[#fab700] text-[10px]'>GB</span>
                </div>
            </div>
            <div className='rounded-tr-md rounded-br-md flex-1 h-12 bg-[#fab700] z-20'>
                <input
                    className={`
                        w-full 
                        h-full 
                        rounded-tr-md 
                        rounded-br-md 
                        bg-[#fab700] 
                        outline-none 
                        px-4 
                        placeholder:text-[#181818]
                        custom-input
                        uppercase
                        ${searchValue && 'font-bold'}
                    `}
                    value={searchValue}
                    onChange={(e) => searchValueHandler(e.target.value)}
                    placeholder='Search to Select'
                />
                {
                    isSearching &&
                    <div className='w-full bg-white h-7 flex flex-col gap-1 items-center py-1 px-1 overflow-hidden overflow-y-auto'>
                        {
                            selectedOption ?
                                <p className='cursor-pointer hover:bg-slate-300 h-7 min-w-full flex items-center' onClick={selectValueHandler}>{selectedOption}</p>
                                :
                                <p className='h-7 min-w-full'>Vehicle not found</p>
                        }
                    </div>
                }
            </div>
            {
                isLoading ?
                    <Spin indicator={<LoadingOutlined spin />} size="small" className='absolute right-3 bottom-[18px] cursor-pointer z-30' />
                    :
                    <div>
                        {hasVehicle ? (
                            <div className='flex suffix'>
                                <FaCircleCheck color='white' className='check-icon absolute right-3 bottom-[18px] cursor-pointer z-30' />
                                <IoCloseCircle color='white' className='close-icon text-[17px] absolute right-[10px] bottom-[16px] cursor-pointer z-30' onClick={resetInput} />
                            </div>
                        ) : (
                            <IoSearch color='white' className='absolute right-3 bottom-[18px] cursor-pointer z-30' onClick={searchIconHandler} />
                        )}
                    </div>
            }
        </div>
    )
}

export default CarRegCustomSelectBox